import React from 'react';
import ReactDOM from 'react-dom/client';
import { startGameOnce } from './game';
import { HUD } from './ui/HUD';

if (import.meta.env.DEV) {
  import("react-grab");
}

const hudRoot = document.getElementById('hud')!;
ReactDOM.createRoot(hudRoot).render(
  <React.StrictMode>
    <HUD />
  </React.StrictMode>,
);

startGameOnce(document.getElementById('game')!);
